
<template>
  <div class="resetFail">
    <v-card class="py-8 px-10">
      <h3 class="mb-6 text-center">重置失敗</h3>
      <div class="information">
        <div>出現未知錯誤，請聯絡我們或再試一次</div>
        <v-icon color="red">fa-times</v-icon>
        <v-btn block rounded color="pink" to="/forget">重新驗證</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.resetFail {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    .v-icon {
      display: block;
      margin: 20px 0;
      font-size: 70px;
    }
    .information {
      text-align: center;
      & > div {
        font-size: 14px;
      }
    }
  }
}
</style>